// extracted by mini-css-extract-plugin
export var contentBody = "_cb-9";
export var headerImage = "_cb-2";
export var imageButton = "_cb-7";
export var imageButtonIcon = "_cb-8";
export var imageHeader = "_cb-4";
export var imageHeaderText = "_cb-5";
export var imageOverlay = "_cb-3";
export var imageTitle = "_cb-6";
export var imageWrapper = "_cb-1";
export var taskList = "_cb-a";
export var widget = "_cb-0";